import { FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";

export function InvoiceFormValidator(group: FormGroup): ValidationErrors | null {
    if (group.value.multiplePayments == false && !group.value.dueDate) {
        return { "dueDateNotPresent": true };
    }
    return null;
}